module.exports = __webpack_public_path__ + "static/media/burger-icon.9a17f46b.svg";